var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('md-layout',{attrs:{"md-align":"center"}},[_c('md-layout',{attrs:{"md-flex":"90"}},[_c('div',{staticClass:"header-component"},[_c('h1',[_vm._v("日本酒居酒屋完全ガイド")]),_vm._v(" "),_c('h4',[_vm._v("日本酒アプリ"),_c('a',{attrs:{"href":"https://www.sakenote.com/"}},[_vm._v("Sakenote")]),_vm._v("ユーザー推薦店！")])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa610fac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = AWgW
// module chunks = 1